export const moneyAmountInfoItemStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		marginBottom: '16px',
		padding: '16px',
		maxWidth: '205px',
		width: '100%',
		backgroundColor: 'var(--default-white)',
		borderRadius: '8px',
		boxShadow: 'var(--box-shadow--1)',
		'&:hover': {
			boxShadow: 'var(--box-shadow--2)',
			transition: 'var(--transition)',
		},
	},

	statistics: {
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		width: '160px',
		height: '160px',
		// cursor: 'pointer',
	},

	icon: {
		'& svg': {maxWidth: '100%'},
	},

	statisticsAmount: {
		color: 'var(--neutral-300)',
		fontWeight: '400',
		whiteSpace: 'nowrap',
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '6px',
	},

	contentInfo: {
		display: 'flex',
		justifyContent: 'space-between',
	},

	contentTitle: {
		display: 'flex',
		alignItems: 'center',
	},

	amount: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
		textAlign: 'center',
	},

	description: {
		paddingLeft: '8px',
		color: 'var(--neutral-500)',
		fontWeight: '400',
	},

	totalAmount: {
		fontWeight: 700,
	},

	outstandingIcon: {
		'& svg circle': {
			fill: 'red',
		},
	},
};
